import React, { useCallback, useEffect, useMemo } from 'react';

import ComponentPropTypes from './ComponentPropTypes';
import _ from 'lodash';
import SelectV2 from 'components/Select/SelectV2';
import { useAuthService } from 'services/AuthService/AuthService';
import { privileges } from 'utils/types';

const iteratee = _.iteratee('id');

export const OrgIdComponent = ({ model, value, onChange }) => {
  const { user } = useAuthService();
  const selectOptions = useMemo(() => {
    const tmp = _.map(user?.organizations, org => {
      if (!model?.properties?.neededPrivilege) {
        return {
          value: org,
          text: org.displayName
        };
      }
      return _.includes(org.privileges, privileges.Any) || _.includes(org.privileges, model?.properties?.neededPrivilege) ?
        {
          value: org,
          text: org.displayName
        } : null;
    });
    return _.compact(tmp);
  }, [model?.properties?.neededPrivilege, user?.organizations]);


  const _onChange = useCallback((selection) => {
    onChange?.(model, selection);
  }, [model, onChange]);

  useEffect(() => {
    // if (_.size(selectOptions) === 1) {
    //   _onChange(selectOptions[0]);
    // }
  }, [_onChange, selectOptions]);

  if (_.size(selectOptions) === 0) {
    return 'No organizations available';
  }

  return (
    <SelectV2 isLoading={user.isLoading} options={selectOptions} value={value} onChange={_onChange} iteratee={iteratee} isDisabled={(_.size(selectOptions) === 1)}/>
  );
};


OrgIdComponent.propTypes = ComponentPropTypes;

export default React.memo(OrgIdComponent);
